import { render, staticRenderFns } from "./questionbank.vue?vue&type=template&id=7552504d&scoped=true"
import script from "./questionbank.vue?vue&type=script&lang=js"
export * from "./questionbank.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7552504d",
  null
  
)

export default component.exports